import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import classnames from 'classnames';
import PortalCouponList from '../../components/PortalCouponList';
import LoadSpinner from "../../components/LoadSpinner";

export class CouponView extends Component {
  constructor(props) {
    super(props);
    this.handleClickMoreReceived = this.handleClickMoreReceived.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleReceiveCoupon = this.handleReceiveCoupon.bind(this);
    this.handleReloadReceivedCoupon = this.handleReloadReceivedCoupon.bind(this);
    this.fetchCouponsMore = this.fetchCouponsMore.bind(this);
    this.createKeyFromCoupon = this.createKeyFromCoupon.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    const { recommendCoupons, scrollTop } = this.props;
    if (this.props.firstTab !== 'coupon') {
      this.props.fetchCouponsReceived();
      if (recommendCoupons.size === 0) {
        this.fetchCouponsMore();
      }
    }
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const container = ReactDOM.findDOMNode(this);
    if (window.pageYOffset + window.innerHeight >= container.offsetHeight + container.offsetTop) {
      this.fetchCouponsMore();
    }
  }
  
  handleClickMoreReceived(e) {
    if (e) {
      e.preventDefault();
    }
    const { handleOpenMore, isOpenCoupon } = this.props;
    handleOpenMore(!isOpenCoupon);
  }

  handleReceiveCoupon(index, couponId) {
    this.props.fetchCouponsReceived();
    this.props.receiveCoupon(index, couponId);
  }

  handleReloadReceivedCoupon() {
    this.props.fetchCouponsReceived();
  }

  createKeyFromCoupon(coupon) {
    return `${coupon.get('id')}-${coupon.get('entryEndAt')}-${coupon.get('modifiedAt')}`;
  }

  fetchCouponsMore() {
    const { recommendCoupons, hasNextCoupon, isFetchingCouponRecommend } = this.props;
    if (!hasNextCoupon || isFetchingCouponRecommend) {
      return;
    }

    let since = null;
    if (recommendCoupons.size > 0) {
      since = this.createKeyFromCoupon(recommendCoupons.last());
    }
    this.props.fetchCouponRecommend(since);
  }
  
  render() {
    const {
      device,
      receivedCoupons,
      recommendCoupons,
      isFetchingCouponReceived,
      isFetchingCouponRecommend,
      isOpenCoupon
    } = this.props;
    const isMoreIcon = receivedCoupons.size > 2;

    return (
      <div className="view_plus">
        <h3 className="screen_out">쿠폰</h3>
        <div className="box_plus">
          <div className="head_coupon" role="text">
            <h4 className="tit_coupon">받은 쿠폰 </h4>
            <em className="emph_count">{receivedCoupons.size}개</em>
          </div>
          <div data-tiara-layer="received_coupon_box">
            <PortalCouponList 
              device={device} 
              coupons={receivedCoupons}
              handleReloadReceivedCoupon={this.handleReloadReceivedCoupon}
              emptyCouponMessage="받은 쿠폰이 없습니다."
              renderCount={!isOpenCoupon ? 2 : receivedCoupons.size}
            />
            {isMoreIcon && (
              <div data-tiara-layer="more">
                <a
                  className={classnames('link_more', { on: isOpenCoupon })}
                  href="#more"
                  onClick={(e) => {this.handleClickMoreReceived(e);}}
                  data-tiara-layer={isOpenCoupon ? 'close' : 'open'}
                >
                  <span className="ico_plus ico_arr" />
                  {!isOpenCoupon && (<em className="emph_count">{receivedCoupons.size-2}개</em>)}
                  {isOpenCoupon ? '접기' : ' 더 보기'}
                </a>
              </div>
            )}
          </div>
        </div>
        <LoadSpinner isFetching={isFetchingCouponReceived}/>
        <a name="recommend" className="anchor"></a>
        <div className="box_plus">
          <div className="head_coupon" role="text">
            <h4 className="tit_coupon">추천 쿠폰 </h4>
          </div>
          <div data-tiara-layer="recommend_coupon_box">
            <PortalCouponList
              device={device}
              coupons={recommendCoupons}
              handleReceiveCoupon={this.handleReceiveCoupon}
              emptyCouponMessage="추천 쿠폰이 없습니다."
              renderCount={recommendCoupons.size}
            />
          </div>
        </div>
        <LoadSpinner isFetching={isFetchingCouponRecommend}/>
      </div>
    );
  }
}

CouponView.propTypes = {
  firstTab: PropTypes.string.isRequired,
  scrollTop: PropTypes.number
};

CouponView.defaultProps = {
  scrollTop: 0
};

const mapStateToProps = (state, {}) => {
  const { device, portal } = state;
  const receivedCoupons = portal.get('receivedCoupons') || Immutable.List();
  const recommendCoupons = portal.get('recommendCoupons') || Immutable.List();
  const isFetchingCouponReceived = portal.get('isFetchingCouponReceived') || false;
  const isFetchingCouponRecommend = portal.get('isFetchingCouponRecommend') || false;
  const isOpenCoupon = portal.get('isOpenCoupon') || false;
  const hasNextCoupon = portal.get('hasNextCoupon') || false;
  return {
    device,
    receivedCoupons,
    recommendCoupons,
    isFetchingCouponReceived,
    isFetchingCouponRecommend,
    isOpenCoupon,
    hasNextCoupon,
  };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal,
    handleOpenMore: actions.updatePortalCouponMore,
    fetchCouponsReceived: actions.fetchCouponsReceived,
    fetchCouponRecommend: actions.fetchCouponRecommend,
    receiveCoupon: actions.receiveCoupon,
  }, dispatch)
)(CouponView);


// WEBPACK FOOTER //
// ./src/containers/PortalPage/CouponView.js